import { ActionTypes } from 'constants/index';

export const submitRegister = ({ fullName, email, password }) => dispatch => {
  dispatch({ type: ActionTypes.REGISTER_LOADING, payload: { fullName, email, password } });
};
